import { motion, useScroll, useTransform } from "framer-motion";
import { type ReactNode, useRef } from "react";
import clsx from "clsx";

type Props = {
  children: ReactNode;
  className?: string;
  /** scroll-driven Y translate range, in px */
  range?: [number, number];
};

/**
 * Wraps children with a scroll-coupled vertical parallax. Use sparingly —
 * one or two big-ticket sections (hero callout, roadmap header).
 */
export function ParallaxSection({ children, className, range = [0, -120] }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], range);

  return (
    <div ref={ref} className={clsx("will-change-transform", className)}>
      <motion.div style={{ y }}>{children}</motion.div>
    </div>
  );
}
